import { width } from '@mui/system'
import IndicatorModal from 'happ-components/Indicators/IndicatorModal'
import { useModal } from 'happ-custom-hooks/useModal/useModal'
import { agendaModal } from 'happ-data/data2'
import React, { useEffect } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'


const arrayOpen = [];
const test = [
    {
        title: 'Chequeo Diagnóstico',
        description:
            [
                { result: 'En esta etapa detectaremos si tienes sospecha de alguna enfermedad cardiovascular.' },
                { result: 'Se realizarán mediciones y exámenes no invasivos.' },
                { result: 'Si detectamos una sospecha, te realizaremos exámenes de sangre para confirmar.' }
            ]

    }
]
const test2 = [
    {
        title: 'Exámenes Físicos',
        description:
            [
                { result: 'En esta etapa realizaremos exámenes no invasivos' },
                { result: 'El objetivo es descartar otras enfermedades asociadas a las que ya hemos diagnosticado' },
                { result: 'Realizaremos un Electrocardiograma, te auscultaremos y evaluaremos si cuentas con edemas' }
            ]

    }
]

const HomeMessage2 = ({ healthIndicators }) => {

    // const [isOpen, openModal, setIsOpen] = useModal(false)

    // aqui podria haber un useEffect escuchando el cambio de estado de la agenda y que haga dispatch cuando cambie... 
    // si el estado de mi agenda es true osea ya tome la hora entonces muestro otro mensaje en este componente junto con una barra de color azul abajo. 

    // useSelector

    // test.map((posi, i) => {

    //     console.log(posi.description)

    // })

    const { openModal, ShowModal } = useModal(arrayOpen, 'homeButton');

    useEffect(() => {

    }, [])

    const statusExamenes = false;
    const horaAgendada = true;
    const status = 'stage2'


    return (

        <div className='blue-stripe'>
            {status === 'stage1' && !horaAgendada ? (
                <>
                    <Row>
                        <Col className=' text-center'>
                            <h1 className='primary-color-text title-message'>Comienza tu viaje</h1>
                            <p className='primary-color-text subtitle-message'>
                                Presiona "Iniciar" para agendar tus horas.
                            </p>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className=' text-center'>
                            <Button onClick={openModal(test)} className='shadow btn-home-message'>
                                {/* <Button  className='shadow btn-home-message'> */}
                                Iniciar
                            </Button>
                        </Col>
                    </Row>
                    <ShowModal />
                </>
            ) : null}
            {status === 'stage1' && horaAgendada ? (
                <>
                    <Row>
                        <Col className=' text-center'>
                            <h1 className='primary-color-text title-message mb-5'>¡Tu hora ya está agendada!</h1>
                            <p className='primary-color-text subtitle-message px-4'>
                                Asiste en ayunas a tu consula el viernes 6 de enero a las 11:00hrs.
                            </p>

                        </Col>
                    </Row>
                </>
            ) : null}
            {status === 'stage2' ? (
                <>
                    <Row>
                        <Col className=' text-center'>
                            <h1 className='fw-bold primary-color-text title-message'>¡Revisa tus resultados!</h1>
                            <p className='primary-color-text lh-1 subtitle-message'>
                                Tus resultados de laboratorio todavía están siendo procesados. Por favor, espera.
                            </p>
                        </Col>
                    </Row>
                    <Row  className='pt-2'>
                        <Col  className='d-flex justify-content-center'>
                            <div className='text-center py-2 fw-bold text-white primary-bg-color rounded-1 indicators-content canvas-message'>
                            Te notificaremos cuando estén disponibles
                            </div>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col className=' text-center'>
                            <h1 className='primary-color-text title-message'>Exámenes de confirmación</h1>
                            <p className='primary-color-text subtitle-message'>
                                Programa tu próxima etapa exámenes de confirmación
                            </p>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className=' text-center'>
                            <Button onClick={openModal(test)} className='shadow btn-home-message'>
                              
                                Iniciar
                            </Button>
                        </Col>
                    </Row>
                    <Row className='pt-2'>
                        <Col className='d-flex justify-content-center'>
                            <div className='text-center py-2 text-white primary-bg-color rounded-1 indicators-content'>
                                Serás notificado cuando estén disponibles
                            </div>
                        </Col>
                    </Row> */}
                </>
            ) : null}
            {status === 'stage3' ? (
                <>
                    <Row>
                        <Col className=' text-center'>
                            <h1 className='fw-bold primary-color-text title-message'>Elige tu hora</h1>
                            <p className='primary-color-text lh-1 subtitle-message'>
                                Revisa tus resultados y agenda tu hora para la siguiente etapa.
                            </p>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        <Col className=' text-center'>
                            <Button onClick={openModal(test2)} className='shadow btn-home-message'>
                                {/* <Button  className='shadow btn-home-message'> */}
                                Agendar aquí
                            </Button>
                        </Col>
                    </Row>
                    <ShowModal />
                </>
            ) : null}

        </div>
    )
}

export default HomeMessage2;